import React, { useContext, useState } from 'react';
import Button from 'components/Button';
import Input from 'components/Input';
import Avatar from 'components/Avatar';
import { SipSocketContext } from 'hooks/useSip/SipSocketContext';
import { getMemberListing } from 'api';
import { LoadingItem } from 'pages/Dashboard';
import ListManager from 'components/ListManager';
import { useAuth } from 'hooks/useAuth';

const MemberListItem = ({ item, ...rest }) => {
  const { user } = useAuth();
  return (
    <label
      htmlFor={item?.uuid}
      key={item?.uuid}
      className="flex items-center justify-between py-3 border-grey-300 border-b cursor-pointer"
    >
      <div className="flex gap-3">
        <div className="relative">
          <Avatar
            name={`${item?.first_name} ${item?.last_name}`}
            mediaUrl={`${process.env.REACT_APP_BASE_API_URL}${
              user?.company_uuid || user?.uuid
            }/profile/${item?.profile_pic}`}
          />
        </div>
        <div className="flex flex-col gap-1">
          <div className="flex items-center text-sm font-medium	 text-white">
            {item?.first_name} {item?.last_name}&nbsp;&nbsp;
            {/* <span>
              <Confrance className-"text-blue-light" />
            </span> */}
          </div>
          <div className="text-xs text-grey-600">{item?.phone}</div>
        </div>
      </div>
      <div className="flex text-xs text-green gap-1">
        <input
          className="checked:bg-green checked:hover:bg-green checked:active:bg-green checked:focus:bg-green focus:outline-none focus:ring-1 focus:ring-green"
          id={item?.uuid}
          type="radio"
          value={item?.extension}
          onChange={(e) => {
            rest?.onChangeItemHandler(e.target.value);
          }}
          checked={Number(item?.extension) === Number(rest?.itemValue)}
        />
      </div>
    </label>
  );
};

const TransferCallComponent = ({ activeCallData }) => {
  const { socket } = useContext(SipSocketContext);
  const { _referUser = () => null } = socket;
  const [transferToNumber, setTransferToNumber] = useState('');

  // # dtmf to remove the person to whom we transfered the call
  // * dtmf to remove the person to perosn who is transfering the call

  const handleTransferNow = () => {
    const ext = transferToNumber;
    if (!ext) return;
    _referUser(
      activeCallData?.callID,
      `${ext}`,
      activeCallData?._status !== 'ringing',
    );
  };

  return (
    <>
      <div className="relative flex flex-col justify-between h-full  xxl:mt-8 xl:mt-3 xxl:min-h-[584px] xxl:max-h-[584px] xl:min-h-[360px] xl:max-h-[360px]">
        <div className="px-6 py-7 pt-0 pb-5">
          <div className={`text-md font-semibold text-white  mb-1`}>
            Transfer call
          </div>

          <Input
            background="bg-grey-100"
            extraClasses="font-unset pl-8 mb-0  "
            placeholder="Search users"
            withSearchIcon={true}
          />
        </div>
        <div className="px-6 py-3 border-grey-300 border-t overflow-auto xxl:max-h-[376px] xl:max-h-[323px] lg:max-h-[314px] md:max-h-[322px] xxl:min-h-[376px] xl:min-h-[323px] lg:min-h-[314px] md:min-h-[322px]">
          <ListManager
            actionFn={getMemberListing}
            queryKey="getMemberListing"
            listItem={MemberListItem}
            loadingComponent={LoadingItem}
            onChangeItemHandler={setTransferToNumber}
            itemValue={transferToNumber}
          />
        </div>
        <div className=" mt-6 px-6 pb-6">
          <Button
            className="mt-10"
            type="button"
            border="border-none"
            disabled={!transferToNumber}
            onClick={() => handleTransferNow()}
          >
            Transfer call
          </Button>
        </div>
      </div>
    </>
  );
};

export default TransferCallComponent;
